import { plural, t } from "@lingui/core/macro";
import React from "react";
import { nameSortingTransformer } from "./utils";
import RefinedListDropdown, {
  DynamicTitleFunction
} from "../RefinementListFilter/RefinedListDropdown";
import RefinedList from "../RefinementListFilter/RefinedList";
import { FycShipsContentFragment } from "types/graphql-types";
import { renderShipPassenderCrew } from "src/utils/ship";
import { RefinementListRenderState } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";
import { DescriptionForItem } from "../RefinementListFilter/RefinedListValues";
import { cruisesLabel } from "src/utils/cruise";

type Props = {
  shipsContent: FycShipsContentFragment[];
};

const descriptionForItem =
  (content: FycShipsContentFragment[]) =>
  (
    item: RefinementListRenderState["items"][number]
  ): ReturnType<DescriptionForItem> => {
    const ship = content?.find((s) => s.name?.trim() == item.value.trim());
    if (!ship) return undefined;

    const version = ship.versions?.[0];
    if (!version) return undefined;

    return renderShipPassenderCrew(version);
  };

const buildDynamicTitle: DynamicTitleFunction = (count) =>
  count > 0
    ? plural(count, {
        one: "# ship selected",
        other: "# ships selected"
      })
    : t`Set the ship`;

export const ShipFilterDropDown: React.FC<Props> = ({ shipsContent }) => {
  return (
    <RefinedListDropdown
      label={t`Ships`}
      dynamicTitle={buildDynamicTitle}
      dataContentPiece="promos_filter_interaction"
      attribute="content.shipName"
      operator="or"
      transformItems={nameSortingTransformer()}
      descriptionForItem={descriptionForItem(shipsContent)}
      limit={100}
      counterLabel={cruisesLabel}
    />
  );
};

export const ShipFilterList: React.FC<Props> = ({ shipsContent }) => {
  return (
    <RefinedList
      title={buildDynamicTitle}
      dataContentName="promos_filter_interaction"
      attribute="content.shipName"
      operator="or"
      transformItems={nameSortingTransformer()}
      descriptionForItem={descriptionForItem(shipsContent)}
      limit={100}
    />
  );
};
